import { FlowService } from '@/services/flow.service';
import { keepPreviousData, queryOptions } from '@tanstack/react-query';

export const listFlowsQuery = queryOptions({
  queryKey: ['list-flows'],
  queryFn: FlowService.list,
  placeholderData: keepPreviousData,
});

export const getFlowQuery = (id: number) =>
  queryOptions({
    queryKey: ['get-flow', id],
    queryFn: () => FlowService.get(id),
  });